import { baseState, baseMutations } from '@/store/mixins'
import thesisTopic from '@/api/thesis-topic'
import level from '@/api/level'
import Year from '@/api/academic-year'
import SubProgram from '@/api/sub-program'
import ClassOperation from '@/api/class-operation'
import Term from '@/api/term-semester'

export const state = {
  ...baseState,
  levels: [],
  edit_data: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_LEVELS (state, data) {
    state.levels = data
  },
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return thesisTopic.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getYear (context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram (context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel (context, attributes = {}) {
    return level.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_levels:
            'level_id,level_name_foreign,level_name_native'
        },
        ...attributes
      }
    })
  },
  getClass (context, attributes = {}) {
    return ClassOperation.get({
      params: Object.assign(
        {
          fields: {
            academic_classes: 'class_id,class_name'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTerm (context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },

  create (context, data) {
    return thesisTopic.store(data)
  },
  update (context, data) {
    return thesisTopic.update(data)
  },
  delete (context, data) {
    return thesisTopic.destroy(data)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await thesisTopic.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
